// extracted by mini-css-extract-plugin
export default {"closeButton":"PopUpShare_closeButton__eV0To","rounded":"PopUpShare_rounded__m0ube"};